import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage.vue'
import AdminMainPage from '../components/AdminMainPage'
import StatisticsPage from '../components/StatisticsPage'
import AnswersBy from '../components/AnswersBy'
import OpenAnswerPage from '../components/OpenAnswerPage'
import RecoveryQuestionnaire from '../components/RecoveryQuestionnaire'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: MainPage
    },
    {
      path: '/operator/:formId',
      name: 'MainOperator',
      component: MainPage,
      props: route => ({isActiveOperatorPanel: true})
    },
    {
      path: '/recovery/operator',
      name: 'RecoveryQuestionnaire',
      component: RecoveryQuestionnaire,
      props: route => ({isActiveOperatorPanel: true})
    },
    {
      path: '/admin/:token',
      name: 'AdminMainPage',
      component: AdminMainPage
    },
    {
      path: '/admin/statistics/:schemaId/:token',
      name: 'StatisticsPage',
      component: StatisticsPage
    },
    {
      path: '/admin/answers_by/:schemaId/:token',
      name: 'AnswersBy',
      component: AnswersBy
    },
    {
      path: '/admin/open_answer/:answerId/:token',
      name: 'OpenAnswerPage',
      component: OpenAnswerPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js